@if (uiConfiguration?.showFileNumber) {
  <div class="flex-container">
    <span class="flex-item-3">{{ 'common.labels.fileNumber2' | transloco }}</span>
    <span class="flex-item-4" data-testid="lien-results-file-number-text">{{ lien?.fileNumber }}</span>
  </div>
}
<div class="flex-container">
  <span class="flex-item-3">{{ 'common.labels.registrationNumber2' | transloco }}</span>
  <span class="flex-item-4" data-testid="lien-results-registration-number-text">{{ results?.registrationNumber }}</span>
</div>
<div class="flex-container">
  <span class="flex-item-3">{{ 'common.labels.registrationDate2' | transloco }}</span>
  <span class="flex-item-4" data-testid="lien-results-registration-date-text">{{ $safeNavigationMigration(results?.registrationDate) | localizedDate: "yyyy-MM-dd" }}</span>
</div>
@if (uiConfiguration?.showResultingExpiryDate) {
  <div class="flex-container">
    <span class="flex-item-3">{{ 'common.labels.expiryDate2' | transloco }}</span>
    <span class="flex-item-4" data-testid="lien-results-expiry-date-text">{{ (lien?.isInfiniteTerm ?? false) ? "NO EXPIRY DATE" : $safeNavigationMigration(results?.expiryDate)  | localizedDate: "yyyy-MM-dd" }}</span>
  </div>
}